import { Button, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IStoreSelectorCtaProps {
  onOpen: () => void;
}

export const StoreSelectorCta: React.FC<IStoreSelectorCtaProps> = ({ onOpen }): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Button
      border={2}
      borderStyle="dashed"
      px={10}
      py={8}
      textAlign="center"
      variant="unstyled"
      onClick={onOpen}
    >
      <Text as="span" display="block" fontWeight="normal" mb={4} whiteSpace="normal">
        {t('STORE.CTA_TITLE')}
      </Text>
      <Text
        _hover={{ textDecor: 'underline' }}
        as="span"
        color="brand.red.light"
        display="block"
        fontSize="h4"
        whiteSpace="normal"
      >
        {t('STORE.CTA_BTN_TEXT')}
      </Text>
    </Button>
  );
};
